import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Sealing_Wet_Rooms() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>      איטום חדרים רטובים</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Sealing_Wet_Rooms">    איטום חדרים רטובים</Link>{" "}
</div>
    </div>
    <div className="video-line" />


      {/* CONTENT */}
<div className="page6">
  <div className="container">

    <div className="content-row2">

     <div className="image-box2">
        <img src="/images/72.jpg" alt="roof" />
      </div>
 
      <div className="text-box">

       <p>  
        איטום חדרים רטובים (מקלחת / שירותים) בדרך כלל נעשה ע"י קבלן הבניין ואין צורך לבצעו בשנית,
אך כאשר אנו כן מבצעים שיפוץ במקלחת / שירותים יש לבצע איטום לרצפה ולקירות החדרים הרטובים ולא לסמוך על השיפוצניק שיבצע את האיטום.
</p>


        <p>  

</p>

        <p>  

</p>
          <h2 className="info-title"> חברת איטומים בגבהים מבצעת איטום בשיטה האיכותית, הטובה והמחמירה ביותר שקיימת.




</h2>





      </div>

    </div>
    <ContactSection2/>
<div className="links2">


  <Link to="/Spray_sealing_of_ground_walls" className="link-right" >     איטום קירות תת קרקעים בהתזה / יריעות ביטומניות </Link>
  <Link to="/Installation_of_high_altitude_infrastructures" className="link-left" >     התקנת תשתיות בגובה </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


